import './App.css';
import './services/Axios/Config';
import CssBaseline from '@mui/material/CssBaseline';
import { BrowserRouter } from 'react-router-dom';
import { UserProvider } from './components/Auth/User';
import Layouts from './layouts';
import InterceptorProvider from './services/Axios/store/InterceptorProvider';
import { SnackbarProvider } from 'notistack';
import VersionControlProvider from './@iosper/components/VersionControl/store/VersionControlProvider';
import { Helmet } from 'react-helmet';
import { Box, StyledEngineProvider } from '@mui/material';
import { ConfigTheme } from './theme/ConfigTheme';
import { ColorModeProvider } from './layouts/context/ColorMode';
import { MenuStateProvider } from './layouts/context/MenuState/MenuStateProvider';

const App = () => {
  return (
    <>
      <Helmet>
        {process.env.REACT_APP_STAGE !== 'production' && (
          <meta name='robots' content='noindex, nofollow' />
        )}
      </Helmet>
      <StyledEngineProvider injectFirst>
        <ColorModeProvider>
          <MenuStateProvider>
            <ConfigTheme>
              <UserProvider>
                <InterceptorProvider>
                  <VersionControlProvider>
                    <SnackbarProvider>
                      <Box>
                        <BrowserRouter>
                          <CssBaseline />
                          <Layouts />
                        </BrowserRouter>
                      </Box>
                    </SnackbarProvider>
                  </VersionControlProvider>
                </InterceptorProvider>
              </UserProvider>
            </ConfigTheme>
          </MenuStateProvider>
        </ColorModeProvider>
      </StyledEngineProvider>
    </>
  );
};
export default App;
